import Image from '../assets/pbz-photo.webp';
import { FaGithub, FaLinkedinIn, FaFile } from 'react-icons/fa';
import { TypeAnimation } from 'react-type-animation';
import { motion } from 'framer-motion';
import { fadeIn } from "../styles/variants";
import { useEffect } from 'react';
import Btn from './Btn';

const Banner = ({activeComp, setActiveComp, pageHeight = 100, refs, handleClick}) => {
  const observerMargin = Math.floor(pageHeight / 2);
  
  useEffect(() => {
    const observerConfig = {
      rootMargin: `-${
        pageHeight % 2 === 0 ? observerMargin - 1 : observerMargin
      }px 0px -${observerMargin}px 0px`,
    };
    const handleIntersection = function(entries) {
      entries.forEach((entry) => {
        if (entry.target.id !== activeComp && entry.isIntersecting) {
          setActiveComp(entry.target.id);
        }
      });
    };
    const observer = new IntersectionObserver(
      handleIntersection,
      observerConfig
    );
    observer.observe(refs['home'].current);
    return () => observer.disconnect(); // Clenaup the observer if component unmount.
  }, [
    activeComp,
    setActiveComp,
    observerMargin,
    refs,
    pageHeight
  ]);

  return (
    <section id="home" ref={refs['home']} className="min-h-[85vh] lg:min-h-[78vh] flex items-center pt-12 pb-12 ">
      <div className='container mx-auto'>
        <div className='flex flex-col gap-y-8 lg:flex-row lg:items-center lg:gap-x-12'>
          {/*text*/}
          <div className='flex-none lg:flex-1 text-center font-secondary lg:text-left'>
            <motion.h1 
              variants={fadeIn('up', 0.3)} 
              initial="hidden"
              whileInView={'show'}
              viewport={{ once: false, amount: 0.7 }}
              className='text-[55px] font-bold leading-[0.8] lg:text-[110px]'
            >
              patrycja <br/>zalas 
            </motion.h1>
            <motion.div 
              variants={fadeIn('up', 0.4)} 
              initial="hidden"
              whileInView={'show'}
              viewport={{ once: false, amount: 0.7 }}
              className='mb-6 text-[36px] lg:text-[60px] font-secondary font-semibold uppercase leading-[1] whitespace-nowrap'
            >
              <span className='mr-4 text-white'>
                I am a
              </span>
              <TypeAnimation sequence={[
                'frontend',
                2000,
                'javascript',
                2000,
                'react',
                2000
              ]}
              speed={50}
              className="text-accent"
              wrapper='span'
              repeat={Infinity}
              />
              <span><br/>developer</span>
            </motion.div>
              
            <motion.p 
              variants={fadeIn('up', 0.5)} 
              initial="hidden"
              whileInView={'show'}
              viewport={{ once: false, amount: 0.7 }}
              className='mb-8 max-w-lg mx-auto lg:mx-0'
            >
              In 2022, I took a leap and trained in modern app development at CodersLab Academy. I quickly absorbed new concepts, while bringing ambitious ideas and a positive attitude to every challenge.
            </motion.p>
            <motion.div 
              variants={fadeIn('up', 0.6)} 
              initial="hidden"
              whileInView={'show'}
              viewport={{ once: false, amount: 0.7 }}
              className='flex max-w-max gap-x-6 items-center mb-12 mx-auto lg:mx-0'
            >
              <button 
                onClick={() => handleClick('resume')}
                className='btn btn-lg cursor-pointer flex items-center'
              >
                Résumé
              </button>
              <Btn text={"My portfolio"} handleClick={handleClick} id={"work"}/>
              <Btn text={"Skills"} handleClick={handleClick} id={"skills"} />
            </motion.div>
            {/*socials*/}
            <motion.div 
              variants={fadeIn('up', 0.7)} 
              initial="hidden"
              whileInView={'show'}
              viewport={{ once: false, amount: 0.7 }}
              className='flex text-[34px] gap-x-6 max-w-max mx-auto lg:mx-0'
            >
              <a href="https://www.linkedin.com/in/patrycja-zalas/" target="_blank" rel="noreferrer" aria-label="Link to PBZ linkedin profile.">
                <FaLinkedinIn />
              </a>
              <a href="https://github.com/propanibutan" target="_blank" rel="noreferrer" aria-label="Link to PBZ github profile.">
                <FaGithub />
              </a>
              <a href="https://drive.google.com/file/d/1NxeGgCfvgn4Aw_DfUhlgW0A3F-l4niKg/view?usp=share_link" target="_blank" rel="noreferrer" aria-label="Link to PBZ resume.">
                <FaFile />
              </a>
            </motion.div>
          </div>
          {/*image*/}
          <motion.div 
            variants={fadeIn('down', 0.5)} 
            initial="hidden"
            whileInView={'show'}
            className='hidden lg:flex flex-1 max-w-[320px] lg:max-w-[482px] mx-auto '
          >
            <img src={Image} alt="Patrycja Zalas." className='photo-radius opacity-90'/>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
